<template>
  <div class="workCont">
    <div class="wksInner_tp">
      <p class="wksInner_tp_p1">{{swiperFrist.title}}</p>
      <p class="wksInner_tp_p2">{{swiperFrist.location}}</p>
      <p class="wksInner_tp_p2">{{swiperFrist.year}}</p>
      <p class="wksInner_tp_p2">{{swiperFrist.area}}</p>
      <div class="ftcontct wirf_d"
           @click="toLink(swiperFrist.url)">{{langFlag ?'MORE':'项目信息 '}}</div>
    </div>
    <i class="wrk_close"
       @click="closeWork()"></i>
    <div class="swiper-container wrk_swiper"
         ref="mySwiper"
         :key="bannerListNowKey">
      <div class="swiper-wrapper">
        <div class="swiper-slide"
             @click="next()"
             v-for="item in swiperData"
             :key="'swiperData' +item.id">
          <div class="wksInner">

            <div class="wksInner_ct"
                 v-show="item.type == 0">
              <!-- <van-image :src="item.pic"
                         class="zp_pic"
                         lazy-load /> -->
              <img :src="item.pic"
                   class="zp_pic"
                   v-lazy="item.pic" />
            </div>
            <div class="wksInner_js"
                 v-show="item.type == 1"
                 v-html="item.desp">{{}}
              <!-- <p class="wksInner_js_p">香水湾位于中国海南省陵水黎族自治县东北部的海滨，位于陵水县城东北18公里，北隔牛岭与万宁市日月湾相邻。香水湾因香水岭流来的泉水注入海湾而得名，其海滨拥有优良沙滩和成片的椰林，现已开发旅游景区，是海南著名的旅游景点。</p>
              <p class="wksInner_js_p">香水湾与万宁市的石梅湾相接，滨海风光奇特。踏入香水湾，首先映入你眼帘的是青翠的椰林，再就是漫无尽头的银色沙滩，低处若毯,高处成丘。香水湾的顶端是牛岭，与分界洲遥遥相望。</p> -->
            </div>
          </div>
        </div>
        <!-- <div class="swiper-slide">
          <div class="wksInner">
            <div class="wksInner_tp">
              <p class="wksInner_tp_p1">香水湾君澜度假酒店</p>
            </div>
            <div class="wksInner_js">
              <p class="wksInner_js_p">香水湾位于中国海南省陵水黎族自治县东北部的海滨，位于陵水县城东北18公里，北隔牛岭与万宁市日月湾相邻。香水湾因香水岭流来的泉水注入海湾而得名，其海滨拥有优良沙滩和成片的椰林，现已开发旅游景区，是海南著名的旅游景点。</p>
              <p class="wksInner_js_p">香水湾与万宁市的石梅湾相接，滨海风光奇特。踏入香水湾，首先映入你眼帘的是青翠的椰林，再就是漫无尽头的银色沙滩，低处若毯,高处成丘。香水湾的顶端是牛岭，与分界洲遥遥相望。</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="wksInner">
            <div class="wksInner_tp">
              <p class="wksInner_tp_p1">香水湾君澜度假酒店</p>
              <p class="wksInner_tp_p2">海南 中国</p>
              <p class="wksInner_tp_p2">2009</p>
              <p class="wksInner_tp_p2">880m²</p>
            </div>
            <div class="wksInner_ct">
              <img src="~@/assets/image/zpnr/zp_pic2.jpg"
                   class="zp_pic" />
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="wksInner">
            <div class="wksInner_tp">
              <p class="wksInner_tp_p1">香水湾君澜度假酒店</p>
              <p class="wksInner_tp_p2">海南 中国</p>
              <p class="wksInner_tp_p2">2009</p>
              <p class="wksInner_tp_p2">880m²</p>
            </div>
            <div class="wksInner_ct">
              <img src="~@/assets/image/zpnr/zp_pic3.jpg"
                   class="zp_pic" />
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="wksInner">
            <div class="wksInner_tp">
              <p class="wksInner_tp_p1">香水湾君澜度假酒店</p>
              <p class="wksInner_tp_p2">海南 中国</p>
              <p class="wksInner_tp_p2">2009</p>
              <p class="wksInner_tp_p2">880m²</p>
            </div>
            <div class="wksInner_ct">
              <img src="~@/assets/image/zpnr/zp_pic4.jpg"
                   class="zp_pic" />
            </div>
          </div>
        </div> -->
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      mySwiper2: null,
      swiperFrist: {},
      bannerListNowKey: 0,
      centerWidth: 0,
      centerHeight: 0,
      swiperData: '',
      wkTit: '',
    }
  },
  computed: {
    ...mapState(['langFlag', 'lang', 'title']),
  },
  // props: ['swiperData', 'sildeIndex'],
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      if (val) {
        document.title = 'work'
      } else {
        document.title = '作品案例'
      }
    },
    // sildeIndex(val) {
    //   if (val == 0) {
    //     this.bannerListNowKey++
    //     this.swiperFrist = this.swiperData[0] || {}
    //     this.$nextTick(function () {
    //       this.wkSwiper()
    //       // this.mySwiper2.update()

    //       // this.$refs.mySwiper.swiper.updateSlides() //更新数量
    //       // this.$refs.mySwiper.swiper.updateSlidesClasses() //更新类名
    //       // this.$refs.mySwiper.swiper.slideTo(0, 0, false)
    //     })
    //   }
    // },
  },
  mounted() {
    this.swiperData = this.$route.query.data || ''
    this.centerWidth = document.documentElement.clientWidth
    this.centerHeight = document.documentElement.clientHeight
    window.onresize = () => {
      this.centerWidth = document.documentElement.clientWidth
      this.centerHeight = document.documentElement.clientHeight
    }

    let that = this
    this.swiperFrist = this.swiperData[0] || {}
    this.wkTit = this.swiperFrist.title
    document.title = this.wkTit
    this.$nextTick(function () {
      this.wkSwiper()
    })
  },

  methods: {
    toLink(url) {
      window.open(url, '_blank') // 打开新窗口
    },
    next() {
      if (document.documentElement.clientWidth > 1000) {
        return false
      }
      this.mySwiper2.slideNext()
    },
    closeWork() {
      console.log('0000')
      this.swiperFrist = {}
      this.$router.back(-1)
      // mySwiper.updateSlides() //更新数量
      // mySwiper.updateSlidesClasses() //更新类名
      this.$nextTick(function () {
        // this.wkSwiper()
        // this.$refs.mySwiper.swiper.updateSlides() //更新数量
        // this.$refs.mySwiper.swiper.updateSlidesClasses() //更新类名
        // this.$refs.mySwiper.swiper.slideTo(0, 0, false)
      })
      // this.$emit('closeWork', false)
    },
    wkSwiper() {
      let that = this
      console.log('dfdfdf', that.centerWidth, JSON.stringify(this.swiperFrist))
      if (that.centerWidth > 768) {
        that.$nextTick(function () {
          that.mySwiper2 = new Swiper('.wrk_swiper', {
            observer: true,
            observeParents: true,
            speed: 0,
            slidesPerView: 'auto',
            centeredSlides: true,
            effect: 'fade',
            // loop: true,
            pagination: {
              el: '.wrk_swiper .swiper-pagination',
              type: 'fraction',
            },
            navigation: {
              nextEl: '.wrk_swiper .swiper-button-next',
              prevEl: '.wrk_swiper .swiper-button-prev',
            },
            on: {
              slideChangeTransitionEnd: function () {
                // alert(this.realIndex) //切换结束时，告诉我现在是第几个slide
                if (this.realIndex == 1) {
                  // that.$refs.videoPlayer.play()
                }
              },
            },
          })
        })
      } else {
        that.$nextTick(function () {
          that.mySwiper2 = new Swiper('.wrk_swiper', {
            observer: true,
            observeParents: true,
            speed: 800,
            slidesPerView: 'auto',
            centeredSlides: true,
            effect: 'silde',
            loop: true,
            // autoplay: {
            //   delay: 3000,
            //   disableOnInteraction: false,
            // },
            navigation: {
              nextEl: '.wrk_swiper .swiper-button-next',
              prevEl: '.wrk_swiper .swiper-button-prev',
            },
            pagination: {
              el: '.wrk_swiper .swiper-pagination',
              // clickable: true,
              type: 'fraction',
            },
          })
        })
      }
    },
  },
}
</script>





// WEBPACK FOOTER //
// src/views/works.vue